<!--
일괄기능 - 상품
------------------------------------
-->
<template>
<div>
    <!-- 버튼영역 -->
    <div class="uk-flex uk-flex-middle uk-flex-wrap uk-flex-between">
        <div>
            <button
                class="uk-button uk-button-small uk-button-black"
                type="button"
                :disabled="disabled"
                v-on:click="$refs.state.jobInit()"
            >
                <i class="material-icons">label</i>
                배송단계변경
            </button>


            <button
                v-if="hasGeneral"
                class="uk-button uk-button-small uk-button-white"
                type="button"
                :disabled="disabled"
                v-on:click="$refs.offSyncState.jobInit()"
                title="배송단계동기화 잠금처리를 설정/해지 합니다. "
            >
                <i class="material-icons">edit</i>
                동기화잠금
            </button>

            <button
                class="uk-button uk-button-small uk-button-white"
                type="button"
                :disabled="disabled"
                v-on:click="$refs.buyordercode.jobInit()"
            >
                <i class="material-icons">receipt</i>
                해외주문번호 입력
            </button>


            <button
                v-if="regionId"
                class="uk-button uk-button-small uk-button-white"
                type="button"
                :disabled="disabled"
                v-on:click="$refs.shippingcenter.jobInit()"
                title="e.g. 델라웨어 배송여부를 설정합니다"
            >
                <i class="material-icons">location_on</i>
                배송지 입력
            </button>


            <button
                class="uk-button uk-button-small uk-button-white"
                type="button"
                :disabled="disabled"
                v-on:click="$refs.trackingno.jobInit()"
            >
                <i class="material-icons">local_shipping</i>
                트래킹번호 입력
            </button>

            <button
                v-if="hasAdmin && onlyGeneralOrUser"
                class="uk-button uk-button-small uk-button-white"
                type="button"
                :disabled="disabled"
                v-on:click="$refs.urgentshipin.jobInit()"
            >
                <i class="material-icons">warning</i>
                긴급입고 설정
            </button>

            <button
                v-if="onlyGeneralOrUser"
                class="uk-button uk-button-small uk-button-dg-w-g uk-button-on-w-r-r"
                type="button"
                :disabled="disabled"
                v-on:click="$refs.hold.jobInit()"
            >
                <i class="material-icons">lock</i>
                보류요청
            </button>

            <button
                v-if="onlyGeneralOrUser"
                class="uk-button uk-button-small uk-button-danger"
                type="button"
                :disabled="disabled"
                v-on:click="$refs['hold-cancel'].jobInit()"
            >
                <i class="material-icons">close</i>
                보류요청취소
            </button>

            <button
                v-if="onlyGeneralOrUser"
                class="uk-button uk-button-small uk-button-white"
                type="button"
                :disabled="disabled"
                v-on:click="$refs['check-request'].jobInit()"
                title="검수요청사항을 작성합니다"
            >
                <i class="material-icons">edit</i>
                검수시요청사항
            </button>

            <button
                v-if="onlyGeneralOrUser"
                class="uk-button uk-button-small uk-button-white"
                type="button"
                :disabled="disabled"
                v-on:click="$refs['pack-req'].jobInit()"
                title="포장요청을 수정합니다"
            >
                <i class="material-icons">edit</i>
                포장요청
            </button>

            <button
                v-if="onlyGeneralOrUser"
                class="uk-button uk-button-small uk-button-white"
                type="button"
                :disabled="disabled"
                v-on:click="$refs['shipout-req'].jobInit()"
                title="출고보류중인 상품을 출고요청합니다"
            >
                <i class="material-icons">exit_to_app</i>
                출고요청
            </button>
        </div>



        <div>
            <button
                v-if="onlyGeneralOrUser || isOsakaWarehouse"
                class="uk-button uk-button-small uk-button-black uk-margin-right"
                type="button"
                :disabled="disabled"
                v-on:click="$refs['house-change-center'].jobInit()"
                title="선택한 주문서를 다른 센터로 이동합니다."
            >
                <i class="material-icons">flip_to_back</i>
                주문서 센터이동
            </button>

            <button
                v-if="onlyGeneralOrUser"
                class="uk-button uk-button-small uk-button-danger"
                type="button"
                :disabled="disabled"
                v-on:click="$refs.cancel.jobInit()"
            >
                <i class="material-icons">close</i>
                배송취소
            </button>

            <button
                v-if="onlyGeneralOrUser"
                class="uk-button uk-button-small uk-button-black"
                type="button"
                :disabled="disabled"
                v-on:click="$refs.delete.jobInit()"
            >
                <i class="material-icons">delete_forever</i>
                상품삭제
            </button>
        </div>

    </div>

    <!-- 단계변경 기능 -->
    <state
        ref="state"
        :batch="batch"
        :csrfToken="csrfToken"
        :has-general="hasGeneral"
        :input-state-options="inputStateOptions"
    ></state>

    <!-- 동기화잠금 기능 -->
    <off-sync-state
        ref="offSyncState"
        :batch="batch"
        :csrfToken="csrfToken"
    ></off-sync-state>

    <!-- 해외주문번호 기능 -->
    <buy-order-code
        ref="buyordercode"
        :batch="batch"
        :csrfToken="csrfToken"
        :region-id="regionId"
    ></buy-order-code>

    <!-- 배송지 기능 -->
    <shipping-center
        v-if="regionId"
        ref="shippingcenter"
        :batch="batch"
        :csrfToken="csrfToken"
        :region-id="regionId"
    ></shipping-center>

    <!-- 트래킹번호 기능 -->
    <tracking-no
        ref="trackingno"
        :batch="batch"
        :csrfToken="csrfToken"
    ></tracking-no>

    <!-- 긴급입고 설정 기능 -->
    <urgent-shipin
        ref="urgentshipin"
        :batch="batch"
        :csrfToken="csrfToken"
    ></urgent-shipin>

    <!-- 보류요청 기능 -->
    <hold
        ref="hold"
        :batch="batch"
        :csrfToken="csrfToken"
    ></hold>

    <!-- 보류요청취소 기능 -->
    <hold-cancel
        ref="hold-cancel"
        :batch="batch"
        :csrfToken="csrfToken"
    ></hold-cancel>

    <!-- 검수시요청사항 기능 -->
    <check-request
        ref="check-request"
        :batch="batch"
        :csrfToken="csrfToken"
    ></check-request>

    <!-- 포장요청 기능 -->
    <pack-req
        ref="pack-req"
        :batch="batch"
        :csrfToken="csrfToken"
    ></pack-req>

    <!-- 출고요청 기능 -->
    <shipout-req
        ref="shipout-req"
        :batch="batch"
        :csrfToken="csrfToken"
    ></shipout-req>

    <!-- 배송취소 기능 -->
    <cancel
        ref="cancel"
        :batch="batch"
        :csrfToken="csrfToken"
    ></cancel>

    <!-- 센터이동 기능 -->
    <house-change-center
        ref="house-change-center"
        :batch="batch"
        :csrfToken="csrfToken"
        :is-osaka-warehouse="isOsakaWarehouse"
    ></house-change-center>

    <!-- 상품삭제 기능 -->
    <delete
        ref="delete"
        :batch="batch"
        :csrfToken="csrfToken"
    ></delete>

</div>
    
</template>

<script>
    export default {
        components: {
            'state': require('./state.vue').default,
            'off-sync-state': require('./off-sync-state.vue').default,
            'buy-order-code': require('./buy-order-code.vue').default,
            'shipping-center': require('./shipping-center.vue').default,
            'tracking-no': require('./tracking-no.vue').default,
            'urgent-shipin': require('./urgent-shipin.vue').default,
            'hold': require('./hold.vue').default,
            'hold-cancel': require('./hold-cancel.vue').default,
            'check-request': require('./check-request.vue').default,
            'pack-req': require('./pack-req.vue').default,
            'shipout-req': require('./shipout-req.vue').default,
            'cancel': require('./cancel.vue').default,
            'house-change-center': require('./house-change-center.vue').default,
            'delete': require('./delete.vue').default,

            //'buy-price-sum': require('./buy-price-sum.vue').default,
        },
        props: {
            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,

            // 지역ID
            regionId: {
                type: Number,
                default: null,
            },

            /**
             * 변경가능한 배송단계 옵션
             */
            inputStateOptions: Array,

            /**
             * 관리자권한 여부
             */
            hasAdmin: {
                type: Boolean,
                default: false
            },

            /**
             * 총괄 관리자 여부
             */
            hasGeneral: {
                type: Boolean,
                default: false
            },

            /**
             * 총괄관리자 & 회원사인지 (창고제한)
             */
            onlyGeneralOrUser: {
                type: Boolean,
                default: false
            },

        },
        data: function () {

            return {
            };
        },
        computed: {
            // 작업 버튼 비활성화 여부
            disabled() {
                // 선택된 아이템없으면 비활성화
                return this.batch.checked_item_count === 0;
            },

            /**
             * 오사카 창고권한인지여부 (항공, 해상모두 포함)
             *
             * @returns {boolean}
             */
            isOsakaWarehouse() {
                if (this.onlyGeneralOrUser) {
                    return false;
                }

                return this.regionId === 9 || this.regionId === 10;
            }
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
</style>